<div class="paxDataResumed__cont">
  <div class="paxDataResumed__data-card">
    <app-ds-data-action-card
      [info]="[
        {
          Type: dataActionCardInfoType.Data,
          Title: paxData.first_name + ' ' + paxData.last_name,
          Subtitle: paxData.document_number ? (documentAbreviation$ | async) + ': ' + paxData.document_number + ' - '  + (paxData.nationality | countryName | async) : (paxData.nationality | countryName | async),
          DataIcon: typeIcon,
          ActionIcon: icons.ChevronRight,
          ActionIdentifier: paxDataAction.PaxInfo
        },
        canShowFrequentNumber && defaultAirlineProgram && {
          Type: hasFrequentFlyerProgram ? dataActionCardInfoType.Data : dataActionCardInfoType.Action,
          Title: hasFrequentFlyerProgram ? ('BOOKING_MODULE.PAX.LOYALTY.LOYALTY_TITLE' | transloco) : ('BOOKING_MODULE.PAX.LOYALTY.FREQUENT_FLYER_NUMBER' | transloco : { name: defaultAirlineProgram }),
          Subtitle: hasFrequentFlyerProgram ? (selectedLoyalty.airline | frequentFlyerName | async) + ': ' + (selectedLoyalty.number) : '',
          DataIcon: hasFrequentFlyerProgram ? icons.Points : icons.AddCircleOutline,
          ActionIcon: hasFrequentFlyerProgram ? icons.ChevronRight : null,
          ActionIdentifier: hasFrequentFlyerProgram ? paxDataAction.LoyaltyInfo : paxDataAction.AddLoyalty
        },
        isMarriottBookingsource && {
          Type: hasBonvoyNumber ? dataActionCardInfoType.Data : dataActionCardInfoType.Action,
          Title: hasBonvoyNumber ? ('BOOKING_MODULE.MARRIOTT_BONVOY.FIDELIZATION_PROGRAM' | transloco) : ('BOOKING_MODULE.MARRIOTT_BONVOY.ADD_BONVOY_NUMBER' | transloco),
          Subtitle: hasBonvoyNumber ? ('BOOKING_MODULE.MARRIOTT_BONVOY.BONVOY' | transloco) + ': ' + (paxData.bonvoy_number) : '',
          DataIcon: hasBonvoyNumber ? icons.MarriottBonvoyFlat : icons.AddCircleOutline,
          ActionIcon: hasBonvoyNumber ? icons.ChevronRight : null,
          ActionIdentifier: paxDataAction.Marriott,
        },
        (activatePassportSection$ | async) && {
          Type: dataActionCardInfoType.Action,
          Title: 'BOOKING_MODULE.PAX.MANDATORY_PASSPORT' | transloco,
          DataIcon: icons.AddCircleOutline,
          ActionIdentifier: paxDataAction.AddPassport,
          ActionIsFailed: hasPassportRestrictionError
        }
      ]"
      (clickEvent)="dataActionEvent($event)">
    </app-ds-data-action-card>
  </div>
  <ng-container *ngIf="paxError">
    <div class="paxDataResumed__error">
      <app-ds-typography
        [size]="fontSize.XXXS"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Warning"
        [text]="errorValue() | transloco: { traveler: travelerLabel | transloco }">
      </app-ds-typography>
    </div>
  </ng-container>
  <ng-container *ngIf="activatePassportSection$ | async">
    <div class="paxDataResumed__error" *ngIf="!addNoLoyaltyClass">
      <div class="paxDataResumed__error-icon">
        <app-ds-icon
          [icon]="icons.Warning"
          [color]="iconFillColor.Warning"
          [size]="12">
        </app-ds-icon>
      </div>
      <app-ds-typography
        [size]="fontSize.XXXS"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Warning"
        [text]="'BOOKING_MODULE.PAX.MANDATORY_ALERT' | transloco">
      </app-ds-typography>
    </div>
  </ng-container>
</div>
